import _ from 'lodash'
import ResizeMixin from './ResizeMixin'
import ResizeBarMixin from './ResizeBarMixin'

export default {
  name: 'KAside',
  mixins: [ResizeBarMixin, ResizeMixin],
  props: {
    width: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resizeBarPlacement: 'right',
    }
  },
  computed: {},
  watch: {},
  methods: {},
  render() {
    const style = _.assign({
      width: this.width,
    }, this.resizeStyle)

    const css = {
      'km-aside': true,
    }

    const attrs = {}

    const props = {
      color: this.type,
      value: this.inputValue,
      lazy: true,
      size: this.size,
    }

    const events = {}

    const data = _.merge({
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }, this.resizeDataForContainer)

    return (
      <aside {...data}>
        {this.$slots.default}
        {this.renderResizeBar()}
      </aside>
    )
  },
}
